"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RegenerateDocumentImageButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const RegenerateImageModal_1 = __importDefault(require("../AppCharacter/RegenerateImageModal"));
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
function RegenerateDocumentImageButton({ document, style, ...restProps }) {
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const [containerWidth, setContainerWidth] = (0, react_1.useState)(0);
    const openModal = (0, react_1.useCallback)(() => setIsModalOpen(true), []);
    const closeModal = (0, react_1.useCallback)(() => setIsModalOpen(false), []);
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { onLayout: (event) => {
            const { width } = event.nativeEvent.layout;
            setContainerWidth(width);
        }, children: [(0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: "Regenerate Image", children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: openModal, style: typeof style === 'function'
                        ? (state) => [styles.button, style(state)]
                        : [styles.button, style], ...restProps, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faRotate, size: 16, color: 'white' }) }) }), (0, jsx_runtime_1.jsx)(RegenerateImageModal_1.default, { isOpen: isModalOpen, onClose: closeModal, document: document }, containerWidth)] }));
}
;
const styles = react_native_1.StyleSheet.create({
    button: {
        backgroundColor: '#00000066',
        padding: 8,
        borderRadius: 16,
    },
});
